<script lang="ts" setup>
const router = useRouter();
const route = useRoute();

const { isGeneric } = defineProps<{ isGeneric?: boolean }>();

function onClick() {
  if (isGeneric) {
    router.back();
    return;
  }

  return navigateTo(route.path.split('/').slice(0, -1).join('/'));
}
</script>

<template>
  <button @click="onClick">
    <SvgoChevronLeft
      :font-controlled="false"
      class="size-6"
      filled
    />
  </button>
</template>
